import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../ui/toast';

interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * 관리자 전용 레이아웃 컴포넌트
 * 헤더에 사용자 정보와 로그아웃 기능을 포함합니다.
 */
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { showToast } = useToast();

  // 로그아웃 처리
  const handleLogout = () => {
    logout();
    showToast('로그아웃되었습니다.', 'success');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 관리자 헤더 */}
      <header className="bg-white shadow-sm border-b">
        <div className="px-2">
          <div className="flex justify-between items-center h-16">
            {/* 로고 및 제목 */}
            <div className="flex items-center">
              <Link to="/admin" className="flex items-center">
                <img 
                  src="/logo_420.jpg" 
                  alt="전시회 관리 시스템" 
                  className="h-10 w-auto"
                />
              </Link>
            </div>

            {/* 사용자 정보 및 로그아웃 */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-3">
                <div className="text-sm">
                  <span className="text-gray-600">관리자:</span>
                  <span className="font-medium text-gray-900 ml-1">
                    {user?.username}
                  </span>
                </div>
                <div className="h-6 w-px bg-gray-300"></div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleLogout}
                  className="text-red-600 hover:text-red-700 hover:bg-red-50"
                >
                  로그아웃
                </Button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* 메인 컨텐츠 */}
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout; 